<template>
    <!-- <div class="w-full h-40px flex items-center px-[15px] "> -->
    <el-popover placement="right" :width="420" trigger="click" :show-arrow="false">
        <template #reference>
            <div class="w-full h-40px flex items-center px-[15px] cursor-pointer">创建设计</div>
        </template>
        <div class="content">
            <size />
        </div>
    </el-popover>

    <!-- </div> -->
</template>
<script lang="ts" setup>
import { ElButton, ElPopover, ElIcon } from 'element-plus'
// @ts-ignore
import size from './size.vue'
</script>
